module.exports = __webpack_public_path__ + "img/cover.2eeb31c5.svg";